import axios from '../config/axios'

const API_BASE = '/vehicle-daily-trips'

const vehicleDailyTripService = {
  // Get all daily trips for a contract
  getByContract: (contractId, filters = {}) => {
    return axios.get(API_BASE, {
      params: { vehicle_contract_id: contractId, ...filters }
    })
  },

  // Get single daily trip
  getOne: (tripId) => {
    return axios.get(`${API_BASE}/${tripId}`)
  },

  // Create new daily trip
  create: (data) => {
    return axios.post(API_BASE, data)
  },

  // Update daily trip
  update: (tripId, data) => {
    return axios.put(`${API_BASE}/${tripId}`, data)
  },

  // Delete daily trip
  delete: (tripId) => {
    return axios.delete(`${API_BASE}/${tripId}`)
  }
}

export default vehicleDailyTripService
